import { useAnimationFrame } from "./sensors/animationFrame";
export function useAnimationFrameThrottle() {
    let lastCallback = null;
    const throttle = (callback) => {
        lastCallback = callback;
    };
    useAnimationFrame(() => {
        if (lastCallback) {
            lastCallback();
            lastCallback = null;
        }
    });
    return {
        throttle,
    };
}
